
import Breadcrumb from '@/components/Breadcrumb'
import GoodsListPage from '@/components/GoodsListPage'
// import { anchorAddNumber, anchorPage } from "@/api/common";

export default {
	components: {
		Breadcrumb,
		GoodsListPage
	},
	data() {
		return {
			pageInfo: {
				page: 1,
				pageSize: 20,
				total: 0
			},
			tvers: []
		}
	},
	methods: {
		handleCurrentChange(page) {
			this.pageInfo.page = page
			this.getAnchorPage()
		},
		handleSizeChange(pageSize) {
			this.pageInfo.page = 1
			this.pageInfo.pageSize = pageSize
			this.getAnchorPage()
		},
		getAnchorPage() {
			let p = {
				action: {},
				page: this.pageInfo.page,
				pageSize: this.pageInfo.pageSize
			}
			this.$api.anchorPage(p).then(res => {
				if (!res.success) {
					this.$message.error(res.info)
					return
				}
				this.pageInfo.total = res.data.total
				this.tvers = res.data.records
			})
		},
		addNumber(id) {
			let p = {
				action: {
					id: id
				}
			}
			this.$api.anchorAddNumber(p).then(res => {
				if (!res.success) {
					this.$message.error(res.info)
				}
			})
		}
	},
	mounted() {
		this.getAnchorPage()
	}
}
